export function Decoration() {
  return null
}

export const KnowMoreLink: TranslationCodesByTenant[keyof TranslationCodesByTenant] =
  'marketplace.banner.faq.targetGuide'
